import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useClientSession } from '@/lib/ClientSessionContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { User, ShoppingBag, FileText, Image as ImageIcon, Database, LogOut, ChevronDown, Menu, X } from 'lucide-react';

export default function PublicNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const { clientUser, logoutClient } = useClientSession();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileProdukOpen, setIsMobileProdukOpen] = useState(false);
  const [isMobileLayananOpen, setIsMobileLayananOpen] = useState(false);

  const getLinkClass = (path) => {
    return pathname.startsWith(path)
      ? "text-[#D4AF37] transition-colors border-b-2 border-[#D4AF37] pb-1"
      : "hover:text-[#D4AF37] transition-colors border-b-2 border-transparent pb-1";
  };

  const getDropdownClass = (prefix) => {
    return pathname.startsWith(prefix)
      ? "flex items-center gap-1.5 text-[#D4AF37] transition-colors outline-none cursor-pointer border-b-2 border-[#D4AF37] pb-1"
      : "flex items-center gap-1.5 hover:text-[#D4AF37] transition-colors outline-none cursor-pointer border-b-2 border-transparent pb-1";
  };

  return (
    <nav className="bg-[#4A3728] text-white sticky top-0 z-50 shadow-md border-b border-[#3A2A1E]">
      <div className="flex justify-between items-center px-5 lg:px-12 py-3.5 md:py-6">
        {/* Left: Logo */}
        <Link to="/" className="flex items-center gap-3 md:gap-4 cursor-pointer">
          <img src="/logo putih.png" alt="Satala Dermatech Essential Logo" className="h-8 md:h-14 w-auto object-contain" />
          <div className="flex flex-col justify-center">
            <span className="font-black text-lg md:text-2xl tracking-tight leading-none text-white">
              Satala Dermatech <span className="text-[#D4AF37] font-extrabold hidden sm:inline">Essential</span>
            </span>
            <span className="font-semibold text-[9px] md:text-[12px] tracking-widest text-[#D4AF37] uppercase mt-0.5 sm:hidden">
              ESSENTIAL
            </span>
          </div>
        </Link>

        {/* Center: Navigation Links */}
        <div className="hidden lg:flex items-center gap-8 xl:gap-12 text-[15px] font-semibold tracking-tight text-white/90">
          <Link to="/tentang-kami" className={getLinkClass('/tentang-kami')}>Tentang Kami</Link>
          
          {/* Product Dropdown */}
          <DropdownMenu>
            <DropdownMenuTrigger className={getDropdownClass('/produk')}>
              Produk <ChevronDown className="w-[15px] h-[15px]" />
            </DropdownMenuTrigger>
            <DropdownMenuContent className="bg-white border border-gray-100 shadow-xl text-gray-700 rounded-2xl w-52 p-2 mt-2">

              <DropdownMenuItem asChild className="py-2.5 px-3 hover:bg-[#F9F5EC] hover:text-[#D4AF37] focus:bg-[#F9F5EC] focus:text-[#D4AF37] cursor-pointer rounded-xl font-medium transition-colors text-[15px]">
                <Link to="/produk/parfum">Parfum</Link>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>

          {/* Services Dropdown */}
          <DropdownMenu>
            <DropdownMenuTrigger className={getDropdownClass('/layanan')}>
              Layanan <ChevronDown className="w-[15px] h-[15px]" />
            </DropdownMenuTrigger>
            <DropdownMenuContent className="bg-white border border-gray-100 shadow-xl text-gray-700 rounded-2xl w-52 p-2 mt-2">
              <DropdownMenuItem asChild className="py-2.5 px-3 hover:bg-[#F9F5EC] hover:text-[#D4AF37] focus:bg-[#F9F5EC] focus:text-[#D4AF37] cursor-pointer rounded-xl font-medium transition-colors text-[15px]">
                <Link to="/layanan/maklon-kosmetik">Maklon Kosmetik</Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild className="py-2.5 px-3 hover:bg-[#F9F5EC] hover:text-[#D4AF37] focus:bg-[#F9F5EC] focus:text-[#D4AF37] cursor-pointer rounded-xl font-medium transition-colors text-[15px]">
                <Link to="/layanan/formulasi">Pengembangan Formulasi</Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild className="py-2.5 px-3 hover:bg-[#F9F5EC] hover:text-[#D4AF37] focus:bg-[#F9F5EC] focus:text-[#D4AF37] cursor-pointer rounded-xl font-medium transition-colors text-[15px]">
                <Link to="/layanan/desain-kemasan">Desain & Kemasan</Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild className="py-2.5 px-3 hover:bg-[#F9F5EC] hover:text-[#D4AF37] focus:bg-[#F9F5EC] focus:text-[#D4AF37] cursor-pointer rounded-xl font-medium transition-colors text-[15px]">
                <Link to="/layanan/legalitas">Legalitas Kosmetik</Link>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>

          <Link to="/partner" className={getLinkClass('/partner')}>Brand Bermitra</Link>
          
          {/* Pricing Dropdown */}
          <DropdownMenu>
            <DropdownMenuTrigger className={getDropdownClass('/pricing')} onClick={() => navigate('/pricing/parfum')}>
              Pricing <ChevronDown className="w-[15px] h-[15px]" />
            </DropdownMenuTrigger>
            <DropdownMenuContent className="bg-white border border-gray-100 shadow-xl text-gray-700 rounded-2xl w-52 p-2 mt-2">

              <DropdownMenuItem asChild className="py-2.5 px-3 hover:bg-[#F9F5EC] hover:text-[#D4AF37] focus:bg-[#F9F5EC] focus:text-[#D4AF37] cursor-pointer rounded-xl font-medium transition-colors text-[15px]">
                <Link to="/pricing/parfum">Parfum</Link>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>

          <Link to="/kontak" className={getLinkClass('/kontak')}>Kontak</Link>
        </div>

        {/* Right: User & Cart Icons */}
        <div className="flex items-center gap-2 md:gap-3">
          {!clientUser ? (
            <>
              <button className="flex items-center gap-2 px-3 py-2 text-white/90 hover:text-[#D4AF37] hover:bg-white/10 rounded-full transition-colors" onClick={() => navigate('/login')} title="Sign In">
                <User className="w-[20px] h-[20px]" />
                <span className="hidden sm:block text-[15px] font-semibold">Log In</span>
              </button>
              
              <button className="p-2 text-white/90 hover:text-[#D4AF37] hover:bg-white/10 rounded-full transition-colors flex items-center justify-center relative" onClick={() => navigate('/login?redirect=/pesan-po')} title="Cart">
                <ShoppingBag className="w-[20px] h-[20px]" />
              </button>
            </>
          ) : (
            <>
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <button className="flex items-center gap-2.5 px-2 py-1.5 text-white/90 hover:bg-white/10 rounded-full transition-colors outline-none cursor-pointer">
                    {clientUser.photo_url || clientUser.profile_picture ? (
                      <img 
                        src={clientUser.photo_url || clientUser.profile_picture} 
                        alt="Profile" 
                        className="w-8 h-8 rounded-full object-cover border border-white/20" 
                      />
                    ) : (
                      <div className="w-8 h-8 rounded-full bg-[#D4AF37] flex items-center justify-center text-[#302621] text-[12px] font-bold shadow-sm">
                        {(clientUser.brand_name || clientUser.company_name || 'P').replace(/\s*\(Google\)/gi, '').substring(0, 1).toUpperCase()}
                      </div>
                    )}
                    <span className="hidden sm:block text-[14px] font-bold text-white truncate max-w-[120px]">
                      {(clientUser.brand_name || clientUser.company_name || 'Profil Klien').replace(/\s*\(Google\)/gi, '')}
                    </span>
                    <ChevronDown className="hidden sm:block w-3.5 h-3.5 text-white/50" />
                  </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-56 p-2 rounded-2xl border-[#E6D5B8]/50 shadow-xl bg-white mt-2">
                  <DropdownMenuLabel className="font-normal px-3 py-2">
                    <div className="flex flex-col space-y-1">
                      <p className="text-[14px] font-semibold leading-none text-[#302621]">{clientUser.company_name}</p>
                      <p className="text-[12px] leading-none text-gray-500">{clientUser.email}</p>
                    </div>
                  </DropdownMenuLabel>
                  <DropdownMenuSeparator className="bg-gray-100" />
                  
                  <DropdownMenuItem className="py-2.5 px-3 cursor-pointer hover:bg-[#F9F5EC] hover:text-[#D4AF37] text-gray-700 rounded-xl transition-colors" onClick={() => navigate('/pesan-po')}>
                    <ShoppingBag className="mr-3 h-[18px] w-[18px]" />
                    <span className="font-medium text-[14px]">Buat Pesanan (PO)</span>
                  </DropdownMenuItem>
                  <DropdownMenuItem className="py-2.5 px-3 cursor-pointer hover:bg-[#F9F5EC] hover:text-[#D4AF37] text-gray-700 rounded-xl transition-colors" onClick={() => navigate('/daftar-pesanan')}>
                    <FileText className="mr-3 h-[18px] w-[18px]" />
                    <span className="font-medium text-[14px]">Daftar Pesanan</span>
                  </DropdownMenuItem>
                  <DropdownMenuItem className="py-2.5 px-3 cursor-pointer hover:bg-[#F9F5EC] hover:text-[#D4AF37] text-gray-700 rounded-xl transition-colors" onClick={() => navigate('/database-produk')}>
                    <Database className="mr-3 h-[18px] w-[18px]" />
                    <span className="font-medium text-[14px]">Database Produk</span>
                  </DropdownMenuItem>
                  <DropdownMenuItem className="py-2.5 px-3 cursor-pointer hover:bg-[#F9F5EC] hover:text-[#D4AF37] text-gray-700 rounded-xl transition-colors" onClick={() => navigate('/profil-saya')}>
                    <User className="mr-3 h-[18px] w-[18px]" />
                    <span className="font-medium text-[14px]">Profil Saya</span>
                  </DropdownMenuItem>
                  
                  <DropdownMenuSeparator className="bg-gray-100" />
                  <DropdownMenuItem className="py-2.5 px-3 cursor-pointer text-red-600 focus:text-red-700 focus:bg-red-50 rounded-xl transition-colors" onClick={() => {
                    logoutClient();
                  }}>
                    <LogOut className="mr-3 h-[18px] w-[18px]" />
                    <span className="font-medium text-[14px]">Log Out</span>
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>

              <button className="relative p-2 text-white/90 hover:text-[#D4AF37] hover:bg-white/10 rounded-full transition-colors flex items-center justify-center" onClick={() => navigate('/pesan-po')} title="Cart">
                <ShoppingBag className="w-[22px] h-[22px]" />
                <span className="absolute top-1 right-1 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-[#4A3728]"></span>
              </button>
            </>
          )}

          {/* Hamburger Menu Icon (Mobile Only) */}
          <button 
            className="lg:hidden p-2 ml-1 text-white/90 hover:text-[#D4AF37] hover:bg-white/10 rounded-full transition-colors flex items-center justify-center"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-[#4A3728] border-t border-[#3A2A1E] px-6 py-5 flex flex-col gap-6 text-[15px] font-semibold tracking-tight text-white/90 animate-in slide-in-from-top-2 duration-200">
          <Link to="/tentang-kami" onClick={() => setIsMobileMenuOpen(false)}>Tentang Kami</Link>
          
          <div className="flex flex-col gap-3">
            <div 
              className="flex justify-between items-center cursor-pointer"
              onClick={() => setIsMobileProdukOpen(!isMobileProdukOpen)}
            >
              <span className={isMobileProdukOpen ? "text-[#D4AF37]" : ""}>Produk</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${isMobileProdukOpen ? 'rotate-180 text-[#D4AF37]' : ''}`} />
            </div>
            {isMobileProdukOpen && (
              <div className="flex flex-col gap-3 border-l-2 border-[#D4AF37] pl-3 mt-1 ml-1 animate-in slide-in-from-top-1">
                <span className="text-[#D4AF37] text-[10px] uppercase tracking-widest font-bold">KATEGORI PRODUK</span>
                <Link to="/produk/parfum" className="text-white/80 hover:text-white" onClick={() => setIsMobileMenuOpen(false)}>Parfum</Link>
              </div>
            )}
          </div>

          <div className="flex flex-col gap-3">
            <div 
              className="flex justify-between items-center cursor-pointer"
              onClick={() => setIsMobileLayananOpen(!isMobileLayananOpen)}
            >
              <span className={isMobileLayananOpen ? "text-[#D4AF37]" : ""}>Layanan</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${isMobileLayananOpen ? 'rotate-180 text-[#D4AF37]' : ''}`} />
            </div>
            {isMobileLayananOpen && (
              <div className="flex flex-col gap-3 border-l-2 border-[#D4AF37] pl-3 mt-1 ml-1 animate-in slide-in-from-top-1">
                <span className="text-[#D4AF37] text-[10px] uppercase tracking-widest font-bold">LAYANAN KAMI</span>
                <Link to="/layanan/maklon-kosmetik" className="text-white/80 hover:text-white" onClick={() => setIsMobileMenuOpen(false)}>Maklon Kosmetik</Link>
                <Link to="/layanan/formulasi" className="text-white/80 hover:text-white" onClick={() => setIsMobileMenuOpen(false)}>Pengembangan Formulasi</Link>
                <Link to="/layanan/desain-kemasan" className="text-white/80 hover:text-white" onClick={() => setIsMobileMenuOpen(false)}>Desain & Kemasan</Link>
                <Link to="/layanan/legalitas" className="text-white/80 hover:text-white" onClick={() => setIsMobileMenuOpen(false)}>Legalitas Kosmetik</Link>
              </div>
            )}
          </div>

          <Link to="/partner" onClick={() => setIsMobileMenuOpen(false)}>Brand Bermitra</Link>
          <Link to="/pricing/parfum" onClick={() => setIsMobileMenuOpen(false)}>Pricing Parfum</Link>
          <Link to="/kontak" onClick={() => setIsMobileMenuOpen(false)}>Kontak</Link>
        </div>
      )}
    </nav>
  );
}
